import React from "react";
import { supabase } from "../supabase";
import TVList from "./TVList";
import Settings from "./Settings";
import GroupList from "./GroupList";

function AdminPanel({ session }) {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold">TV Management</h1>
            </div>
            <div className="flex items-center">
              <span className="text-gray-500 mr-4">{session.user.email}</span>
              <button
                onClick={handleSignOut}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid gap-6">
          <Settings userId={session.user.id} />
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-semibold mb-4">My Groups</h2>
            <GroupList userId={session.user.id} />
          </div>
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-semibold mb-4">My TVs</h2>
            <TVList userId={session.user.id} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
